import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { SchedoraLogo } from "@/components/schedora/SchedoraLogo";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-md rounded-2xl border bg-card p-8 shadow-card text-center">
        <SchedoraLogo iconOnly iconClassName="h-10 w-10 mx-auto mb-5" />
        <h1 className="mb-3 text-4xl font-heading font-bold">404</h1>
        <p className="mb-5 text-base text-muted-foreground">The page you were looking for does not exist or may have moved.</p>
        <Link to="/">
          <Button>Return Home</Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
